import { useEffect, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { bussinesRoutes } from './allRoutes';
import { getLoggedUserPermissions } from '../services/configuration.service';

const switchRoutes = (
  <Switch>
    {bussinesRoutes.map((prop, key) => {
      if (prop.layout === 'organization') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/organization" to="/organization-list" />
  </Switch>
);

const Bussines = () => {
  const { user } = useUserAuth();
  const [existNudosData, setExistNudosData] = useState<boolean>(false);

  const getNudosData = async () => {
    if (!localStorage.getItem('userNudosData') && user) {
      const nudosData = await getLoggedUserPermissions(user?.uid);
      localStorage.setItem('userNudosData', JSON.stringify(nudosData));
      setExistNudosData(true);
    } else if (localStorage.getItem('userNudosData') && user) {
      setExistNudosData(true);
    }
  };

  useEffect(() => {
    getNudosData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  return <> {user && existNudosData && switchRoutes} </>;
};

export default Bussines;
